module.exports = __webpack_public_path__ + "fonts/fa-brands-400.f37f3d6d.woff2";